import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { FALLBACK_NOTIFICATION_COUNT } from 'src/environments/go-api-fallbacks'

import { ApiService } from '@shared/services/api.service'
import { withoutErrorPageRedirect } from '@app/core/interceptors/error-redirect-context'
import { NotificationMessage } from './notification-message.model'
import { PagesData } from '@shared/models/pages-data.model'
import { VehicleView } from '@app/modules/client/map/shared/models/map.type'
import { FilterValues } from '@shared/models/filter-values.model'
@Injectable()
export class NotificationService {
  constructor(private apiService: ApiService) {}

  // L30-2705: the bell's list and unread count load on every page; a 500 from them must not throw the
  // user onto the error page (callers fall back to an empty list / the fallback count).
  getList(pageIndex = 1, pageSize = 10): Observable<PagesData<NotificationMessage>> {
    return this.apiService.getPageable<NotificationMessage>(
      '/notifications/messages',
      pageIndex,
      pageSize,
      undefined,
      undefined,
      undefined,
      undefined,
      withoutErrorPageRedirect(),
    )
  }

  getListNotificationsVehicleById(
    id: number,
    filterValues: FilterValues,
    sort: string,
    pageIndex = 1,
    pageSize = 10,
    view = VehicleView.Vehicle,
  ): Observable<PagesData<NotificationMessage>> {
    const path = `/notifications/messages/${view === VehicleView.Asset ? 'asset' : 'vehicle'}/${id}`

    return this.apiService.getPageable<NotificationMessage>(path, pageIndex, pageSize, sort, filterValues)
  }

  getUnreadCount(): Observable<number> {
    return this.apiService.get('/notifications/messages/count', { context: withoutErrorPageRedirect() }).pipe(
      map((res) => res['data'].count),
      catchError(() => of(FALLBACK_NOTIFICATION_COUNT)),
    )
  }

  markAsRead(id: string): Observable<void> {
    return this.apiService.post(`/notifications/messages/${id}/read`, null) as any
  }

  markAllAsRead(): Observable<void> {
    return this.apiService.post('/notifications/messages/read', null) as any
  }
}
